import "@arco-design/web-react/es/Drawer/style";
import _Drawer from "@arco-design/web-react/es/Drawer";
import "@arco-design/web-react/es/Alert/style";
import _Alert from "@arco-design/web-react/es/Alert";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import { useSelector } from 'react-redux';
import Block from './block';
import ColorPanel from './color';
import IconButton from '../NavBar/IconButton';
import useLocale from '@/utils/useLocale';
function Setting(props) {
  const {
    trigger
  } = props;
  const [visible, setVisible] = useState(false);
  const locale = useLocale();
  const settings = useSelector(state => state.settings);
  function onCopySettings() {
    copy(JSON.stringify(settings, null, 2));
    _Message.success(locale['settings.copySettings.message']);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, trigger ? ( /*#__PURE__*/React.cloneElement(trigger, {
    onClick: () => setVisible(true)
  })) : /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(_IconSettings, null),
    onClick: () => setVisible(true)
  }), /*#__PURE__*/React.createElement(_Drawer, {
    width: 300,
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_IconSettings, null), locale['settings.title']),
    visible: visible,
    okText: locale['settings.copySettings'],
    cancelText: locale['settings.close'],
    onOk: onCopySettings,
    onCancel: () => setVisible(false)
  }, /*#__PURE__*/React.createElement(Block, {
    title: locale['settings.themeColor']
  }, /*#__PURE__*/React.createElement(ColorPanel, null)), /*#__PURE__*/React.createElement(Block, {
    title: locale['settings.content'],
    options: [{
      name: 'settings.navbar',
      value: 'navbar'
    }, {
      name: 'settings.menu',
      value: 'menu'
    }, {
      name: 'settings.footer',
      value: 'footer'
    }, {
      name: 'settings.menuWidth',
      value: 'menuWidth',
      type: 'number'
    }]
  }), /*#__PURE__*/React.createElement(Block, {
    title: locale['settings.otherSettings'],
    options: [{
      name: 'settings.colorWeek',
      value: 'colorWeek'
    }]
  }), /*#__PURE__*/React.createElement(_Alert, {
    content: locale['settings.alertContent']
  })));
}
export default Setting;